  import environment from 'environment';

import { TransactionForm } from "../transactionform.model";

export class EcopayzForm extends TransactionForm {
  constructor(customerProducts, paymentOptions) {
    super(customerProducts, paymentOptions);
  }

  toPayload() {
    let payload = super.toPayload();

    payload['returnUrl'] = environment.ECOPAYZ_SUCCESS_URL;
    payload['failureUrl'] = environment.ECOPAYZ_FAILURE_URL;
    payload['cancelUrl'] = environment.ECOPAYZ_CANCELATION_URL;
    
    return payload;
  }
}



// WEBPACK FOOTER //
// ./client/app/pages/customer/deposit/component/form/ecopayz/ecopayzform.model.js